/**
 * @generated SignedSource<<50bbb8f6e548231c559e9614b7ee5f70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkGroup_frontGroup$data = {
  readonly links: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TaglineLink_tagLineLink">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "LinkGroup_frontGroup";
};
export type LinkGroup_frontGroup$key = {
  readonly " $data"?: LinkGroup_frontGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkGroup_frontGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkGroup_frontGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaglineLink",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaglineLink_tagLineLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LinkGroup",
  "abstractKey": null
};

(node as any).hash = "d282b60c90f77480b4098692a8d8a9d1";

export default node;
